import {
  Box,
  Button,
  Heading,
  HStack,
  Spinner,
  Stack,
  Text,
} from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getJournalTemplates } from '../../stores/slices/journalTemplates/journalTemplatesActions';
import { setActiveJournal } from '../../stores/slices/journalTemplates/journalTemplatesSlice';

const JournalList = props => {
  const { journalTemplates, listLoading, activeJournal } = useSelector(
    state => state.journalTemplates
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getJournalTemplates());
    // eslint-disable-next-line
  }, []);
  return (
    <Box
      // minW={'300px'}
      overflow="auto"
      {...props}
      borderRight={'1px'}
      borderColor={'gray.500'}
      pr={'2'}
    >
      <Stack
        justifyContent={'space-between'}
        alignContent={'center'}
        direction={'row'}
        w={'full'}
        spacing={2}
        borderBottom={'1px'}
        borderColor={'gray.500'}
        pt={'1'}
        pb={'3'}
        mb={'4'}
      >
        <HStack>
          <Heading as={'h4'} size="md">
            Templates
          </Heading>
        </HStack>
      </Stack>
      {listLoading ? (
        <Spinner color="primary" />
      ) : journalTemplates.length > 0 ? (
        <Box w={'full'}>
          {journalTemplates.map(template => (
            <Button
              variant={'outline'}
              key={template.id}
              color={'black'}
              mb={'2'}
              size={'sm'}
              w={'full'}
              justifyContent={'start'}
              onClick={() => dispatch(setActiveJournal(template))}
              isActive={
                activeJournal ? template.id === activeJournal.id : false
              }
            >
              {template.name}
            </Button>
          ))}
        </Box>
      ) : (
        <Text>No Templates found.</Text>
      )}
    </Box>
  );
};

export default JournalList;
